import React, {useState, useEffect, useContext, useCallback} from 'react';
import {useParams} from "react-router";
import {LoadingIndicator} from '../../components/loadingIndicator/loadingIndicator';
import {APIGetMyPlans} from "../../api/plans/Plans";
import CardGrid from "../../components/cardview/cardGrid";
import NotFound from "../../assets/search.jpg";
import { ListContext } from "../../context/ListContext";
import { UserContext } from '../../context/UserContext';
import {verifyPermissions} from "../../helper/getProductSettingsHandler";

export const PlanIndex = ({data}) => {
	const {user, company} = useContext(UserContext);
	const {type} = useParams();
	const [list, setList] = useState(null);
	const [tags, setTags] = useState(null);
	const [openTagSearchModal, setOpenTagSearchModal] = useState(false);

	const settings = {
		all: {
			type:"myPlans",
			title:"Meine Pläne",
			limit: verifyPermissions(company, "planMax"),
			creationAllowed: verifyPermissions(company, "planCreation"),
			creationLabel:"Neuen Plan erfassen",
			upgrade: '/products/morePlans',
			creationType:"map",
			createDialog:{
				image:NotFound,
				text: "Es wurden noch keine Pläne hinterlegt."
			},
			deleteDialog:{
				headline:"Plan löschen",
				text: "Mit Löschung werden sämtliche Daten des Plans, sowie sämtliche zugehörige Daten unwiderruflich gelöscht.",
				button: "Endgültig löschen"
			},
			filterByCommunities: verifyPermissions(company, "communityFilter"),
			filter: verifyPermissions(company, "additionalFilter"),
			search:{
				searchAllows: verifyPermissions(company, "planSearch"),
				searchTags: verifyPermissions(company, "planSearchTags"),
				text:"Bezeichnung oder Plan-Nummer",
			},
			uploadPlanAllows: verifyPermissions(company, "planCreation"),
			actions:{
				planOpen:true,
				planCreation:verifyPermissions(company, "planCreation"),
				planDelete:verifyPermissions(company, "planDelete"),
				refUpload:true,
				planDownload:true,
				// todo: certificate is Broken
				//planCertificatedCreate: verifyPermissions(company, "planCertificate"),
				planOrderChange: verifyPermissions(company, "planOrderChange"),
				planLinkViewer:true,
			},
			tableColumns: {
				createdAt:"Erstellt am",
				planId:"Nummer",
				type:"Art",
				name:"Bezeichnung",
			}
		}
	}
	const currentSetting = settings?.[(typeof type !== "undefined")? type : "all"];

	const addTagDetails = (data,label) => {
		var response = {
			name: label,
			count: 1
		}

		if(typeof data?.count !== "undefined") {
			response.count = data?.count+1;
		}

		return response;
	};

	const tagGenerator = useCallback((data) => {
		if(data !== null) {

			var tagsCategory = {};
			for(var k =  0; k < data.length; k++) {
				// setup tags for Plan
				data[k]["tags"] = [];

				// Add type per tags
				if(typeof data[k]?.type !== "undefined") {

					// Set Tags for Stage
					if(typeof tagsCategory["type"] === "undefined") {
						tagsCategory["type"] = {
							name:"Plan-Art",
							options:{}
						};
					}

					if(data[k]?.type === "BP_Plan") {
						data[k]["tags"].push("BP_Plan");
						tagsCategory["type"]["options"]["BP_Plan"] = addTagDetails(tagsCategory?.["type"]?.["options"]?.[data[k]?.type],"BP Plan");
					} else if(data[k]?.type === "FP_Plan") {
						data[k]["tags"].push("FP_Plan");
						tagsCategory["type"]["options"]["FP_Plan"] = addTagDetails(tagsCategory?.["type"]?.["options"]?.[data[k]?.type],"FNP Plan");
					}

				}

				// Add type per tags
				if(typeof data[k]?.companiesname !== "undefined") {

					// Set Tags for Stage
					if(typeof tagsCategory["creator"] === "undefined") {
						tagsCategory["creator"] = {
							name:"Plan-Inhaber",
							options:{}
						};
					}

					data[k]["tags"].push(data[k]?.companiesname);
					tagsCategory["creator"]["options"][data[k]?.companiesname] = addTagDetails(tagsCategory?.["creator"]?.["options"]?.[data[k]?.companiesname],data[k]?.companiesname);

				}
			}

			setTags(tagsCategory);
		}
		return data;
	}, []);

	const fetchListData = useCallback(async () => {
		const plans = await APIGetMyPlans(user?.companyId);
		const taggedPlans = tagGenerator(plans);

		setList(taggedPlans);
	}, [tagGenerator, user?.companyId]);

	useEffect(() => {

		if (user === undefined) { return; }
	  
		fetchListData();

	}, [fetchListData, user]);



	return list === null ? (
		<div className='flex w-full h-dvh justify-center items-center'>
			<LoadingIndicator/>
		</div>
	) : (
		<div className={"mx-auto max-w-7xl orderDetails"}>
			<main>
				<div className="w-full flex">
					<ListContext.Provider value={{list,openTagSearchModal, setOpenTagSearchModal, setList, type, tags, currentSetting, fetchListData}}>
						<CardGrid/>
					</ListContext.Provider>
				</div>
			</main>
		</div>
	)

	

}
